export enum ProfileSubPages {
  myProfile = 'my',
  legalNotes = 'legal-notes',
  myAvailabilities = 'my-availabilities',
}
